import React from 'react';
import {useQuickViewAutoAddToWishlist} from './hooks/useQuickViewAutoAddToWishlist';

interface AutoAddToWishlistQuickViewProps {
  productId: number;
}

/**
 * Component that automatically adds a product to the wishlist when mounted.
 * Used in quick views to add items without redirecting away from the quick view.
 * Shows a success toast notification when the item is added.
 */
export const AutoAddToWishlistQuickView: React.FC<
  AutoAddToWishlistQuickViewProps
> = ({productId}) => {
  useQuickViewAutoAddToWishlist(productId);
  return null;
};
